import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import { getFunctions } from 'firebase/functions'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
}

const app = initializeApp(firebaseConfig)
export const db = getFirestore(app)
export const auth = getAuth(app)
export const functions = getFunctions(app)
export const storage = getStorage(app)

const REGION = 'us-central1'
const PROJECT_ID = process.env.REACT_APP_FIREBASE_PROJECT_ID

export async function callCreateUser(data: object) {
  const idToken = await auth.currentUser?.getIdToken()
  if (!idToken) throw new Error('Not authenticated')
  const response = await fetch(`https://${REGION}-${PROJECT_ID}.cloudfunctions.net/createUser`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${idToken}` },
    body: JSON.stringify({ data }),
  })
  const result = await response.json()
  if (!response.ok) throw new Error(result.error?.message || `Function call failed: ${response.status}`)
  return result
}

export async function callCreateUsersBulk(users: { email: string; name: string; role: string }[], targetOrgId: string) {
  const idToken = await auth.currentUser?.getIdToken()
  if (!idToken) throw new Error('Not authenticated')
  const response = await fetch(`https://${REGION}-${PROJECT_ID}.cloudfunctions.net/createUsersBulk`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${idToken}` },
    body: JSON.stringify({ data: { users, targetOrgId } }),
  })
  const result = await response.json()
  if (!response.ok) throw new Error(result.error?.message || `Function call failed: ${response.status}`)
  return result
}